module.exports = __webpack_public_path__ + "img/dex_oidc.fb5c0fab.png";